import { createFileRoute } from '@tanstack/react-router';
import type { JSX } from 'react';

import { FlexibleCalculationTemplateNewPage } from '@/areas/flexible-calculations/FlexibleCalculationTemplates/FlexibleCalculationTemplateNewPage';
import { canViewFlexibleCalculationTemplates } from '@/shared/permissions/pagePermissions';
import type { PageStaticData } from '@/shared/routing';
import { SidebarPageContent } from '@/shared/ui/PageLayoutCollapsibleSidebar';

export const Route = createFileRoute('/_authenticated/next/templates/flexible-calculation/create')({
    staticData: {
        access: { permissions: canViewFlexibleCalculationTemplates },
        chrome: 'none',
    } satisfies PageStaticData,
    component: RouteComponent,
});

function RouteComponent(): JSX.Element {
    return (
        <SidebarPageContent layoutVariant="fullWidth">
            <FlexibleCalculationTemplateNewPage />
        </SidebarPageContent>
    );
}
